export const appsAggregatePushCredentialInfo = "/apps/aggregate_push_credential_info";
